define([
	"dojo/_base/declare",
	"csi/resolver",
	"csi/table/NewFrom",
	"csi/xml",
	"csi/xml/Query",
	"Apparel/CopyStyleMixin",
	"Apparel/StructureItemMixin"
], function (declare, resolver, NewFrom, xml, Query, CopyStyleMixin, StructureItemMixin) {

	return declare([NewFrom, CopyStyleMixin, StructureItemMixin], {
		defaultsAttribute: "StyleType",

		_toWriterSource: function () {
			this.preloadSourceNodes();
			return this.inherited(arguments);
		},

		/**
		 * @override
		 * pass destination structure item URL so correct themes / shapes get populated based on season availability
		 */
		onCreatePopupParams: function(params) {
			params.destStructureItem = this.getParent();
		},

		/**
		 * @override
		 * return initial filters for popup view
		 */
		_getViewFilters: function () {
			var url = this._resolveStyleType(this.getParent());
			if (url) {
				var styleType = resolver.resolveNode(url);
				this.m_cache.cacheNode(styleType);
				return new Query().Attr(xml.ATTR_NAME, xml.OP_EQUALS, styleType.$Name, "Child:ProductType").getElements();
			}

			return null;
		},

		/**
		 * @override
		 * return remove ProductType from automatic ChangeNode
		 * C8-50236 - Fix Performance Issue
		 */
		toWriterFields: function(/*String*/urlNode, /*FormData?*/fd, /*Function*/filter) {
			// swallow product type
			fd = fd || this.m_formData; // in case form data isn't loaded yet
			fd.getFieldValue("ProductType", true);
			this.inherited(arguments);
		}
	});
});